import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Leads from '../views/Leads.vue'
import LeadForm from '../views/LeadForm.vue'
import Customers from '../views/Customers.vue'
import CustomerForm from '../views/CustomerForm.vue'
import Situazione from '../views/Situazione.vue'
import Ordini from '../views/Ordini.vue'
import Fatture from '../views/Fatture.vue'
import Analisi from '../views/Analisi.vue'
import Nuovo from '../views/Nuovo.vue'
import Quotazione from '../views/Quotazione.vue'
import Quotazioni from '../views/Quotazioni.vue'

Vue.use(VueRouter)

const routes = [
  { path: '/', name: 'Home', component: Home },
  { path: '/lead', name: 'Lead', component: Leads },
  { path: '/lead/:id', name: 'LeadForm', component: LeadForm },
  { path: '/customer', name: 'Clienti', component: Customers },
  { path: '/customer/:id', name: 'CustomerForm', component: CustomerForm },
  { path: '/situazione', name: 'Situazione', component: Situazione },
  { path: '/ordini', name: 'Ordini', component: Ordini },
  { path: '/fatture', name: 'Fatture', component: Fatture },
  { path: '/analisi', name: 'Analisi', component: Analisi },
  { path: '/nuovo', name: 'Nuovo', component: Nuovo },
  { path: '/customer/quotazione/:id', name: 'Quotazione', component: Quotazione, props: true },
  { path: '/quotazioni', name: 'Cataloghi', component: Quotazioni },
]

const router = new VueRouter({
  routes
})

export default router
